import { Link } from "react-router-dom";

interface EmptyStateProps {
  message: string;
  hint?: string;
  actionHref?: string;
  actionText?: string;
}

export default function EmptyState({ message, hint, actionHref, actionText }: EmptyStateProps) {
  return (
    <div className="w-full rounded-lg border border-dashed border-background-300 bg-background-100 py-16 px-6 text-center">
      <div className="mx-auto w-14 h-14 flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
        <i className="ri-inbox-line text-3xl"></i>
      </div>
      <p className="mt-4 text-base font-heading font-semibold text-foreground-700">{message}</p>
      {hint && <p className="mt-2 text-sm text-foreground-500">{hint}</p>}
      {actionHref && (
        <Link
          to={actionHref}
          className="mt-5 inline-flex items-center gap-1 rounded-md bg-primary-500 px-4 py-2 text-sm font-label font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          {actionText ?? "去看看"}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}